import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'reactstrap';
import Loader from '../common/Loader.jsx';
import PropTypes from 'prop-types';

const subjects = { 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {}, 7: {}, 8: {}, 9: {} };

const ShtuffSkeleton = props => {
	const { version } = props;
	const [showV2, setShowV2] = useState();

	useEffect(() => {
		let skel = version === 'v2';

		setShowV2(skel);
	}, []);

	return (
		<Row className={'mt-5 shtuff skeleton'} id={'shtuff'} aria-hidden="true">
			<Col col={'col-12'}>
				{ !showV2 && <h2 className={'display-heading text-center'}>Shtuff you get, sorted by subject!</h2> }
				<Row className={'mt-4 justify-content-center'}>
					{Object.keys(subjects).map((key, item) =>
						<div key={key} className={'col-12 col-md-6 col-lg-4 mb-5 mx-2 subject-card-wrapper' +
						(showV2 ? ' dark' : '')} >
							<Card className={'subject-or-classroom'} col={'sm-2'} key={key} data-item={item}>
								<div className={'display-heading swipe-under text-center pt-2'} />
								<div className={'subject-links'}>
									{<Loader/>}
								</div>
							</Card>
						</div>
					)}
				</Row>
			</Col>
		</Row>
	);
};

export default ShtuffSkeleton;

ShtuffSkeleton.propTypes = {
	version: PropTypes.string
};
